var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.40625 20.8438C0.609375 21.6406 0.578125 23.0781 1.42188 23.9219C2.26562 24.7656 3.70312 24.7344 4.5 23.9531L13 15.4531L21.4844 23.9375C22.3125 24.7656 23.7188 24.7656 24.5625 23.9062C25.3906 23.0625 25.4062 21.6562 24.5781 20.8438L16.0938 12.3594L24.5781 3.85938C25.4062 3.04688 25.4062 1.625 24.5625 0.796875C23.7188 -0.046875 22.3125 -0.046875 21.4844 0.765625L13 9.25L4.5 0.75C3.70312 -0.03125 2.26562 -0.0625 1.42188 0.78125C0.59375 1.625 0.609375 3.0625 1.40625 3.85938L9.90625 12.3594L1.40625 20.8438Z","fill":"currentColor"}));
}

X.defaultProps = {"width":"26","height":"25","viewBox":"0 0 26 25","fill":"currentColor"};

module.exports = X;

X.default = X;
